import React from 'react';
import TasksDonutChart from './TasksDonutChart';
import EstimatedEffortBars from './EstimatedEffortBars';
import WeeklyCapacityCards from './WeeklyCapacityCards';

/**
 * WeeklyWorkOverview Component
 * Unified block containing:
 * 1. Tasks Donut Chart (5 statuses, weekly completed only, interactive filtering)
 * 2. Estimated & Effort Progress Bars
 * 3. Weekly Capacity Cards
 */
export default function WeeklyWorkOverview({
    statusCounts = {},
    selectedStatus = null,
    onStatusSelect,
    estimatedMinutes = 0,
    effortMinutes = 0,
    remainingMinutes = 0,
    totalCapacityMinutes = 2400,
    remainingCapacityMinutes = 2400,
}) {
    return (
        <div className="bg-white dark:bg-[#1f1f1f] border border-slate-200/80 dark:border-[#303030] rounded-2xl p-6 shadow-xs transition-all">
            {/* Header matching specification */}
            <div className="flex flex-wrap items-center justify-between pb-6 border-b border-slate-100 dark:border-[#303030] gap-4">
                <div>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-white font-headline tracking-tight">
                        Weekly Work Overview
                    </h2>
                    <p className="text-sm text-slate-500 dark:text-slate-400 font-medium mt-1">
                        A snapshot of your tasks, time, and capacity for the current week.
                    </p>
                </div>
                <div className="flex items-center gap-2">
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-slate-50 dark:bg-[#2d3748] border border-slate-200 dark:border-slate-700 text-xs font-bold text-slate-700 dark:text-slate-200 rounded-lg shadow-2xs font-headline">
                        <span className="material-symbols-outlined text-sm text-blue-600">calendar_today</span>
                        <span>This Week</span>
                    </span>
                </div>
            </div>

            {/* 3 Columns divided by subtle vertical lines */}
            <div className="grid grid-cols-1 lg:grid-cols-3 divide-y lg:divide-y-0 lg:divide-x divide-slate-100 dark:divide-[#303030] pt-6 gap-8">
                {/* Column 1: Tasks Donut */}
                <TasksDonutChart
                    statusCounts={statusCounts}
                    selectedStatus={selectedStatus}
                    onStatusSelect={onStatusSelect}
                />

                {/* Column 2: Estimated & Effort */}
                <EstimatedEffortBars
                    estimatedMinutes={estimatedMinutes}
                    effortMinutes={effortMinutes}
                    remainingMinutes={remainingMinutes}
                    maxCapacityMinutes={totalCapacityMinutes}
                />

                {/* Column 3: Weekly Capacity */}
                <WeeklyCapacityCards
                    totalCapacityMinutes={totalCapacityMinutes}
                    remainingCapacityMinutes={remainingCapacityMinutes}
                />
            </div>
        </div>
    );
}
